import { getView, requireAuth } from '@/lib/utils';
import { PageMaterialCreate } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/materials/create',
  component: getView('pages/PageMaterialEdit'),
  name: 'createNewMaterial',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Materials > Create New',
    leftMenu: Left.MaterialsList,
    roles: ['operator'],
    information: PageMaterialCreate,
    showBottomMenu: true,
  },
};
